import { createFeatureSelector, createSelector } from '@ngrx/store';
import { fromError } from '../reducers';
export const getErrorRootState = createFeatureSelector('error');
export const getErrorState = createSelector(getErrorRootState, state => state);
const errorSelectors = fromError.errorAdapter.getSelectors(getErrorState);
export const getAllErrors = errorSelectors.selectAll;
export const getErrorEntities = errorSelectors.selectEntities;
/**
 * Selector to return the number of current errors
 */
export const getErrorCount = createSelector(getAllErrors, errors => errors.length);
/**
 * Selector to return if there are any errors
 */
export const getHasError = createSelector(getErrorCount, errorCount => errorCount !== 0);
//# sourceMappingURL=error.selectors.js.map